/**
 * @fileoverview
 */
import fetch from "@lib/fetch";

import { userInfoCacheKey } from "../../appsUserInfo";
import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import {
  testUserNamesCacheKey,
  internalUserGroupsCacheKey,
  appSettingsInternalUserGroupsDeleteTestUserCacheKeys,
} from "./constants";
import type { UpdateTestUserBody, TestUserUpdateResult } from "./types";

export const postTestUser = reactQueryMutationAdapter(
  [
    userInfoCacheKey,
    testUserNamesCacheKey,
    internalUserGroupsCacheKey,
    ...appSettingsInternalUserGroupsDeleteTestUserCacheKeys,
  ],
  (body: UpdateTestUserBody): Promise<TestUserUpdateResult> => {
    return fetch("/internal_user_groups/test_user", "POST", body);
  }
);
